<div class="file-drop-area">
  <ngx-file-drop
    dropZoneLabel="Dateiablage"
    (onFileDrop)="onFileDropped($event)"
  >
    <ng-template ngx-file-drop-content-tmp>
      <label class="custom-file-button">
        Datei auswählen
        <input
          type="file"
          multiple
          [disabled]="isUploading"
          (change)="fileBrowseHandler($event)"
        />
      </label>
    </ng-template>
  </ngx-file-drop>
</div>

<h3>Ausgewählte Dateien:</h3>
<ul>
  @for (file of oldFiles; track file; let i = $index) {
    <li>
      <strong>{{ extractFilename(file) }}</strong>
      <button
        type="button"
        class="remove-button"
        title="Wird beim Speichern endgültig gelöscht"
        [disabled]="isUploading"
        (click)="removeOldFile(i)"
      >
        Entfernen
      </button>
    </li>
  }
</ul>
<ul>
  @for (file of files; track file; let i = $index) {
    <li>
      <strong>{{ file.name }}</strong>
      <button
        type="button"
        class="remove-button"
        [disabled]="isUploading"
        (click)="removeFile(i)"
      >
        Entfernen
      </button>
    </li>
  }
</ul>
